/* Crazy Egg behaviour tracking for the tag product page (pdp-v2/crazyegg.py, 2026-10-03).
 *
 * Three layers, so most of it works whatever the Crazy Egg plan allows:
 *  - Recording tags (CE2.addTag): what this visitor did, to filter recordings by.
 *  - User variables (CE2.set 1-5): segments heatmaps and recordings.
 *      1 market   2 traffic source   3 checkout path   4 furthest step   5 basket at checkout
 *  - Named goals (CE2.goalConversion): counted once the account has Conversions on;
 *    the script ignores them silently until then.
 * Each visitor also gets a random id (cookie sn_ce_vid) passed to CE2.identify. The Stripe
 * checkout carries it to supernormal-web, whose webhook reports the paid order to Crazy
 * Egg's Conversion Tracking API under the same id ("Purchase").
 *
 * Every call goes through the CE_API queue, so nothing breaks if Crazy Egg is slow,
 * blocked or removed. Each tag and goal fires at most once per page view.
 */
(function () {
  'use strict';

  function ce(fn) {
    (window.CE_API || (window.CE_API = [])).push(function () {
      try { if (window.CE2) fn(window.CE2); } catch (e) { /* tracking must never break the page */ }
    });
  }
  var done = {};
  function once(key) { if (done[key]) return false; done[key] = true; return true; }
  function tag(name) { if (once('t:' + name)) ce(function (c) { c.addTag(name); }); }
  function goal(name, value) {
    if (!once('g:' + name)) return;
    ce(function (c) { if (c.goalConversion) c.goalConversion(value != null ? { name: name, value: value } : { name: name }); });
  }
  function setVar(slot, value) { ce(function (c) { c.set(slot, String(value).slice(0, 100)); }); }

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* ── Visitor id shared with the server-side purchase conversion ── */
  var vid = cookie('sn_ce_vid');
  if (!/^[a-z0-9-]{8,64}$/i.test(vid)) {
    vid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    document.cookie = 'sn_ce_vid=' + vid + '; path=/; max-age=' + 60 * 60 * 24 * 365 + '; SameSite=Lax';
  }
  ce(function (c) { if (c.identify) c.identify(vid); });

  /* ── 1 market, 2 traffic source (first touch this browser session) ── */
  var S = window.Shopify || {};
  setVar(1, (S.country || '?') + ' / ' + ((S.currency && S.currency.active) || '?'));

  var source = '';
  try { source = sessionStorage.getItem('sn_ce_src') || ''; } catch (e) {}
  if (!source) {
    var q = new URLSearchParams(location.search);
    if (q.get('utm_source')) source = q.get('utm_source') + (q.get('utm_medium') ? ' / ' + q.get('utm_medium') : '');
    else if (q.get('fbclid')) source = 'facebook / paid-click';
    else if (q.get('gclid')) source = 'google / cpc';
    else {
      var ref = '';
      try { ref = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : ''; } catch (e) {}
      source = ref && ref.indexOf('supernormalpets.com') === -1 ? ref : 'direct';
    }
    try { sessionStorage.setItem('sn_ce_src', source); } catch (e) {}
  }
  setVar(2, source);

  /* ── 4 furthest step reached ── */
  var STEPS = ['viewed product', 'opened buy modal', 'continued to checkout', 'reached Stripe checkout'];
  var reached = 0;
  function step(name) {
    var i = STEPS.indexOf(name);
    if (i > reached || (i === 0 && reached === 0)) { reached = Math.max(i, 0); setVar(4, STEPS[reached]); }
  }
  step('viewed product');

  /* ── Helpers that read the buy modal's current state ── */
  function modalOpen() { var d = document.querySelector('.pdp2-buy'); return !!(d && d.hasAttribute('open')); }
  function checked(sel, attr) { var el = document.querySelector(sel + '[aria-checked="true"]'); return el ? el.getAttribute(attr) : ''; }
  function qty() { var el = document.getElementById('quantitySelect'); return el ? (parseInt(el.value, 10) || 1) : 1; }
  function cycle() { var c = document.querySelector('[data-care-summary]'); return (c && c.dataset.careCycle) || 'monthly'; }
  function basket() {
    var style = checked('[data-pdp2-style]', 'data-pdp2-style') || 'standard';
    var colour = style === 'engraved' ? '' : ' ' + (checked('[data-pdp2-colour]', 'data-pdp2-colour') || '').toLowerCase();
    return style + colour + ' x' + qty() + ', ' + cycle();
  }
  function sectionOf(el) {
    var s = el.closest('[id^="shopify-section-"]');
    return s ? s.id.replace(/.*__/, '') : '';
  }
  var PLACE = { hero: 'hero', features: 'features', care_plans: 'care plans', cta: 'closing CTA', steps: 'steps', app: 'app section' };
  function label(el) { return (el.innerText || el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 60); }

  var continued = false;

  /* Window capture runs before the page's own handlers, some of which stop the event. */
  window.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('a, button, summary, [role="button"]');
    if (!el) return;
    var sec = sectionOf(el);

    // Buy buttons. The modal's Continue clicks #orderNowButton for real; that pass is not a "buy" press.
    if (el.matches('#orderNowButton, #stickyOrderNowButton, a.cp-cta, a[href="#care-order"], a[href="#orderNowButton"]')) {
      // Synthetic clicks are forwards (care-plans CTA -> #orderNowButton, modal Continue): count the original only.
      if (modalOpen() || (el.id === 'orderNowButton' && !e.isTrusted)) return;
      var place = el.id === 'stickyOrderNowButton' ? 'sticky bar' : (PLACE[sec] || sec || 'page');
      tag('Buy button: ' + place);
      goal('PDP - Buy button');
      step('opened buy modal');
      return;
    }

    // Continue only counts once checkout really starts (see onCheckoutStart); a press the page
    // refuses - an engraved tag without its first line - is tagged as blocked instead.
    if (el.matches('[data-pdp2-checkout]')) {
      setTimeout(function () { if (!continued) tag('Continue blocked (engraving missing)'); }, 50);
      return;
    }

    if (el.matches('[data-pdp2-close]')) { if (!continued) tag('Closed buy modal without checkout'); return; }
    if (el.matches('[data-pdp2-style]')) { tag('Chose ' + el.getAttribute('data-pdp2-style')); return; }
    if (el.matches('[data-pdp2-colour]')) { tag('Colour: ' + el.getAttribute('data-pdp2-colour').toLowerCase()); return; }
    if (el.matches('[data-care-qty], [data-cp-pets]')) { setTimeout(function () { tag('Pets: ' + qty()); }, 0); return; }
    if (el.matches('[data-care-cycle-opt]')) { tag('Chose ' + el.getAttribute('data-care-cycle-opt')); return; }
    if (el.matches('[data-cp-cycle]')) { tag('Care plans: ' + label(el).split(' ')[0].toLowerCase()); return; }
    if (el.matches('[data-care-tip-btn]')) { tag('Opened trial details'); return; }
    if (el.matches('[data-pdp2-play]')) { tag('Played story: ' + label(el).replace(/^Play\s+/, '').replace(/'s story$/, '')); return; }
    if (el.matches('[data-cp-app-link]')) { tag('Start Care in the app'); goal('PDP - Start Care in app'); return; }
    if (el.matches('a[href*="apps.apple.com"], a[href*="play.google.com"]')) {
      tag('App store: ' + (/apple/.test(el.href) ? 'iOS' : 'Android'));
      goal('PDP - App store link');
      return;
    }
    if (el.matches('summary') && sec === 'faq') { tag('FAQ: ' + label(el)); return; }
  }, true);

  /* Checkout has started: the page marks the buy button busy (setBusy) on both the Stripe
     and the Shopify path, after its own validation has passed. */
  function onCheckoutStart() {
    if (continued) return;
    continued = true;
    var sc = window.pdp2StripeCheckout;
    var path = sc && sc.wanted && sc.wanted() ? 'stripe' : 'shopify';
    setVar(3, path);
    setVar(5, basket());
    tag('Checkout: ' + (path === 'stripe' ? 'Stripe' : 'Shopify'));
    goal('PDP - Continue to checkout');
    step('continued to checkout');
  }
  function watchBusy() {
    var btn = document.getElementById('orderNowButton');
    if (!btn || !window.MutationObserver || btn.__ceWatched) return;
    btn.__ceWatched = true;
    new MutationObserver(function () { if (btn.getAttribute('aria-busy') === 'true') onCheckoutStart(); })
      .observe(btn, { attributes: true, attributeFilter: ['aria-busy'] });
  }
  watchBusy();
  document.addEventListener('DOMContentLoaded', watchBusy);

  /* First keystroke in an engraving field. */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-engraving-input]')) tag('Typed engraving');
  }, true);

  /* Stripe checkout: count the hand-off, and the fallback when it fails. */
  function wrapStripe() {
    var sc = window.pdp2StripeCheckout;
    if (!sc || sc.__ceWrapped) return;
    var start = sc.start;
    sc.start = function (o) {
      tag('Reached Stripe checkout');
      goal('PDP - Stripe checkout started');
      step('reached Stripe checkout');
      return start.call(this, o).catch(function (err) {
        tag('Stripe failed, fell back to Shopify');
        setVar(3, 'shopify (Stripe failed)');
        throw err;
      });
    };
    sc.__ceWrapped = true;
  }
  wrapStripe();
  document.addEventListener('DOMContentLoaded', wrapStripe);
})();
